import React, { Component } from "react";
import './myBlogHome.css';
//
import { Link } from "react-router-dom";
// Services
import { BlogsHome } from "../Service/data";
import { ChangedData } from "../../assets/ChangedData/ChangedData";


class MyBlogHome extends Component{

    constructor(){
        super();
        this.state = {
            HomeBlogsObjects: [],
        }
    }

    
    componentDidMount(){
        this.getblogsHome();
        
        let WaiteTime = 150;
        const ScrollAnimation = (elements) =>{
            let index = 0;
            let Elementslength = elements.length;
        
            const Loop = () =>{
                setTimeout(() => {
                    if (index < Elementslength) {
                        elements[index].classList.remove("ScrollAnimation");
                        index++;
                        Loop();
                    }
                }, WaiteTime);
            }
            Loop();
        }

        let NotCalled = true;
        window.addEventListener("scroll" , ()=>{
            let ScrollAniElements = document.querySelectorAll(".ScrollAnimation");
            let windowH = window.innerHeight;
            let TopmainBlogHomeContainer = document.querySelector("#mainBlogHomeContainer").getBoundingClientRect().top;
            let BottommainBlogHomeContainer = document.querySelector("#mainBlogHomeContainer").getBoundingClientRect().bottom;


            if (windowH / 1.7 >  TopmainBlogHomeContainer && BottommainBlogHomeContainer > windowH / 1.8 && NotCalled === true) {
                ScrollAnimation(ScrollAniElements);
                NotCalled = false;
            }
        });
    }
    componentWillUnmount(){
        let WaiteTime = 150;
        const ScrollAnimation = (elements) =>{
            let index = 0;
            let Elementslength = elements.length;
        
            const Loop = () =>{
                setTimeout(() => {
                    if (index < Elementslength) {
                        elements[index].classList.remove("ScrollAnimation");
                        index++;
                        Loop();
                    }
                }, WaiteTime);
            }
            Loop();
        }

        let NotCalled = true;
        window.removeEventListener("scroll" , ()=>{
            let ScrollAniElements = document.querySelectorAll(".ScrollAnimation");
            let windowH = window.innerHeight;
            let TopmainBlogHomeContainer = document.querySelector("#mainBlogHomeContainer").getBoundingClientRect().top;
            let BottommainBlogHomeContainer = document.querySelector("#mainBlogHomeContainer").getBoundingClientRect().bottom;


            if (windowH / 1.7 >  TopmainBlogHomeContainer && BottommainBlogHomeContainer > windowH / 1.8 && NotCalled === true) {
                ScrollAnimation(ScrollAniElements);
                NotCalled = false;
            }
        });
    }


    getblogsHome(){
        BlogsHome().then((data)=>{
            this.state.HomeBlogsObjects = data;
        })
    }

    clickToEditAtUi(event){
        var Uitarget = event.target.getAttribute("uitarget");
        document.getElementById(Uitarget).click();
        this.ToolsZu();
    }
    onHoverTargetElement(event){
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.add("targetToEditClass");
    }
    onHoverOutTargetElement(event){
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.remove("targetToEditClass");
    }








    clickToEditAtUi(event){
        var Uitarget = event.target.getAttribute("uitarget");
        document.getElementById(Uitarget).click();
        this.ToolsZu();
    }
    onHoverTargetElement(event){
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.add("targetToEditClass");
    }
    onHoverOutTargetElement(event){
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.remove("targetToEditClass");
    }


    toTextEditFunction(event){
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {

                if ( textArea.value.length > 0) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = event.target.getAttribute("data-f");
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    // AllData[APIfileName][atributname] = textafter;

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        if ( !ChangedData[APIfileName]) {
                            // ChangedData[APIfileName] = AllData[APIfileName];
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
        
        }
    }


    hoverEditOn(event){
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    hoverEditOut(event){
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }






















    render(){
        return(
            <div>
                <div id="Blog" className="ScreenRouteDiv"></div>
                <div className="mainBlogHomeContainer d-flex flex-column justify-content-center align-items-center" id="mainBlogHomeContainer">
                    <div className="mainBlogHomeContainerIN d-flex flex-column justify-content-center align-items-center">
                        
                        <div className="myHomeBlogHeader d-flex flex-column justify-content-center align-items-center">
                            <p className="myBlogmainTitle" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut}>My Blog</p>
                            <p className="myBlogMainUderTxt" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut}>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p>
                            <a href="/Blogs?c=all">
                                <div class="hierMeButtonContainer d-flex align-items-center justify-content-center" id="AllBlogsBTN">
                                    SEE ALL
                                </div>
                            </a>
                        </div>

                        <div className="ArticHomeBlogMainContainer d-flex justify-content-between align-items-start flex-wrap">


                        { this.state.HomeBlogsObjects.map( Blog => 
                            <div className="BlogCard ScrollAnimation">
                                <a href={"/Blog?id=" + Blog.id}>
                                    <div className="BlogCardImageContainer">
                                        <img className="BlogCardImage" src={Blog.BlogImage} alt="Blog Image" />
                                    </div>
                                </a>
                                <div className="BlogCardTitleContainer">
                                      <p className="BlogCardTitle"> <a href={"/Blog?id=" + Blog.id}> { Blog.BlogTitle } </a></p>
                                </div>

                                <div className="BlogCardInfoDatum">
                                    { Blog.date + " " }  { Blog.author } <i className="fas fa-comment-dots"></i> { Blog.CommentsNumber }
                                </div>

                                <div className="ContentOfBlogContainer">
                                     <p className="ContentOfBlog">A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            
                            </div>

                            
                        )}


                        </div>
                    
                    </div>

                </div>
            </div>
        );
    }
}


export default MyBlogHome;













{/*
                            <div className="BlogCard ScrollAnimation">
                                <a href="/Blog">
                                    <div className="BlogCardImageContainer">
                                        <img className="BlogCardImage" src="https://www.datensen.com/media/pictures/data-model-mongodb.jpg" alt="Image" />
                                    </div>
                                </a>
                                <div className="BlogCardTitleContainer">
                                      <p className="BlogCardTitle"> <a href="/blog">Entity Relationship Modell (ER-Modell / ERM)</a></p>
                                </div>

                                <div className="BlogCardInfoDatum">
                                    Sept. 12, 2019 Admin <i className="fas fa-comment-dots"></i> 0
                                </div>

                                <div className="ContentOfBlogContainer">
                                    <p className="ContentOfBlog">A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                            


                            <div className="BlogCard ScrollAnimation">
                                <a href="/Blog">
                                    <div className="BlogCardImageContainer">
                                        <img className="BlogCardImage" src="https://images.unsplash.com/photo-1602992708529-c9fdb12905c9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80" alt="Image" />
                                    </div>
                                </a>
                                <div className="BlogCardTitleContainer">
                                <p className="BlogCardTitle"> <a href="/blog">Why1 Lead Generation is Key for the Business Growth </a></p>
                                </div>

                                <div className="BlogCardInfoDatum">
                                    Sept. 12, 2019 Admin <i className="fas fa-comment-dots"></i> 3
                                </div>

                                <div className="ContentOfBlogContainer">
                                    <p className="ContentOfBlog">A small river named Duden flows by their place and supplies it with the necessary regelialia ......</p>
                                </div>
                            </div>
                            

                            <div className="BlogCard ScrollAnimation">
                                <a href="/Blog">
                                    <div className="BlogCardImageContainer">
                                        <img className="BlogCardImage" src="https://images.unsplash.com/photo-1603468620905-8de7d86b781e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2352&q=80" alt="Image" />
                                    </div>
                                </a>
                                <div className="BlogCardTitleContainer">
                                <p className="BlogCardTitle"> <a href="/blog">Why1 Lead Generation is Key for the Business Growth </a></p>
                                </div>

                                <div className="BlogCardInfoDatum">
                                    Sept. 12, 2019 Admin <i className="fas fa-comment-dots"></i> 3
                                </div>

                                <div className="ContentOfBlogContainer">
                                    <p className="ContentOfBlog">A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        */}